import * as React from 'react';
import { Config } from './session-video-player/helper';
import { isChinaDomain } from './utils/language';

function buildConfig(options) {
  const config = { ...Config.DefaultOptions, ...options };

  config.uiConfId = Config.Defaults.uiConfId;
  config.forChina = isChinaDomain();

  return config;
}

export default function SessionVideoPlayer(props) {
  const {
    id,
    playlist_id: playlistID,
    session_id: sessionID,
    class: classNames = '',
  } = props;

  const widgetElement = React.useRef(null);

  React.useEffect(() => {
    if (!widgetElement.current) return;

    const config = buildConfig({
      elementId: id,
      sessionId: sessionID,
      playlistId: playlistID,
    });

    const dispatcher = window.isEditorPage
      ? document.querySelector('.gjs-frame')?.contentWindow
      : window;

    const POLL_INTERVAL = 100;
    const MAX_WAIT = 10000;
    let elapsed = 0;

    const interval = setInterval(() => {
      const lib =
        dispatcher?.NvidiaSearchLibrary?.EventSessionVideoPlayerWidget;

      if (!lib) {
        elapsed += POLL_INTERVAL;
        if (elapsed >= MAX_WAIT) {
          console.warn('SessionVideoPlayer: library failed to load within timeout');
          clearInterval(interval);
        }
        return;
      }

      clearInterval(interval);

      try {
        lib.unmountById(id);
      } catch (e) {
        console.warn('SessionVideoPlayer: unmount failed', e);
      }

      lib.mount(config);
    }, POLL_INTERVAL);

    return () => clearInterval(interval);
  }, [id, playlistID, sessionID]);

  const cssClasses = [
    'nv-session-video-player',
    ...classNames.split(' ').map((i) => i.trim()),
  ].filter((i) => i.length > 0);

  return (
    <div className={cssClasses.join(' ')}>
      <div id={id} ref={widgetElement}></div>
    </div>
  );
}
